import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/carousel.css'

class Carousel extends Component {
  constructor (props) {
    super(props)
    const itemsToShow = (this.props.itemsToShow !== undefined) ? this.props.itemsToShow : 2
    const autoplay = (this.props.autoplay !== undefined) ? this.props.autoplay : true
    this.setCurrent = this.setCurrent.bind(this)
    this.state = {
      currentItem: 0,
      itemsToShow,
      autoplay,
      autoplaySpeed: 7000,
      paused: false
    }
  }

  componentWillUnmount () {
    this.stop = true
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.state.currentItem !== nextState.currentItem
  }

  autoplay (itemCount) {
    const {currentItem, itemsToShow} = this.state
    const carousel = this
    function setNext () {
      if (this.stop !== true) {
        const nextItem = ((currentItem + itemsToShow) < itemCount) ? currentItem + 1 : 0
        if (carousel.state.paused !== true) {
          carousel.setState({currentItem: nextItem})
        }
      }
    }
    setTimeout(setNext.bind(this), this.state.autoplaySpeed)
  }

  setCurrent (currentItem) {
    this.setState({currentItem, paused: true})
  }

  formatChildren (children) {
    const {currentItem, itemsToShow} = this.state
    const {setCurrent} = this
    return React.Children.map(children, function (child, index) {
      const active = (index >= currentItem && index <= currentItem + (itemsToShow - 1))
      let goTo

      if (index === (currentItem + itemsToShow)) {
        goTo = currentItem + 1
      } else if (index === (currentItem - 1)) {
        goTo = currentItem - 1
      }

      // const goTo2 = ((currentItem + itemsToShow) < children.count) ? currentItem + 1 : currentItem - 1
      return (
        <li key={index} onClick={() => { if (goTo !== undefined) { setCurrent(goTo) } }} className={'carouselItem' + (active ? ' active' : ' inactive')}>
          {
            React.cloneElement(child, {
              active: active
            })
          }
        </li>
      )
    })
  }

  render () {
    const {currentItem, itemsToShow, autoplay} = this.state
    const width = (window.innerWidth > 800) ? this.props.children.length * (1000 / itemsToShow) : `${this.props.children.length * 100}%`
    const transform = `translate3d(${(currentItem / this.props.children.length) * -100}%,0,0)`
    if (autoplay) this.autoplay(this.props.children.length)
    return (
      <div className='carousel'>
        <div className='carouselFrame' style={{width, transform}}>
          <ul>
            {this.formatChildren(this.props.children)}
          </ul>
        </div>
        <ul className='dots'>
          {
            [...Array(this.props.children.length - (itemsToShow - 1))].map(
              (item, index) => <li key={index} onClick={() => this.setCurrent(index)} className={(index === this.state.currentItem) ? 'active' : ''} />
            )
          }
        </ul>
      </div>
    )
  }
}

Carousel.propTypes = {
  itemsToShow: PropTypes.number,
  autoplay: PropTypes.bool,
  children: PropTypes.node.isRequired
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/Carousel.js